exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nsvg[data-v-17db0c1a] {\n  border: 1px solid #999;\n  border-radius: 0.5em;\n}\n", ""]);

// exports
